import { type MessageDescriptor, i18n } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import type { OPPORTUNITY_ACTIVITY_SEARCH_PARAM_KEYS } from '@/router/searchParams/opportunitySearchParams';

export type NON_QUERY_PARAM_FIELDS = 'w.name' | 'w.metrics.lastActivityDate';

export type ALL_OPPORTUNITY_ACTIVITY_FIELDS = Exclude<
  OPPORTUNITY_ACTIVITY_SEARCH_PARAM_KEYS,
  'audience'
>;

const OPPORTUNITY_ACTIVITY_FIELD_MESSAGES: Record<
  ALL_OPPORTUNITY_ACTIVITY_FIELDS,
  MessageDescriptor
> = {
  'o.companyId': msg`Company`,
  'o.status': msg`Status`,
  'o.amount': msg`Amount`,
  'o.vendorIdListPipelineInfluence': msg`Pipeline Influence by Vendor`,
  'o.vendorIdListClosedwonInfluence': msg`Closed Won Influence by Vendor`,
  'o.vendorIdListPipelineFirstTouch': msg`Pipeline First Touch by Vendor`,
  'o.vendorIdListPipelineLastTouch': msg`Pipeline Last Touch by Vendor`,
  'o.vendorIdListPipelineLinear': msg`Pipeline Linear by Vendor`,
  'o.vendorIdListClosedwonFirstTouch': msg`Closed Won First Touch by Vendor`,
  'o.vendorIdListClosedwonLinear': msg`Closed Won Linear by Vendor`,
  'o.campaignTypeIdListPipelineInfluence': msg`Pipeline Influence by Offline Event`,
  'o.campaignTypeIdListClosedwonInfluence': msg`Closed Won Influence by Offline Event`,
  'o.campaignTypeIdListPipelineFirstTouch': msg`Pipeline First Touch by Offline Event`,
  'o.campaignTypeIdListPipelineLastTouch': msg`Pipeline Last Touch by Offline Event`,
  'o.campaignTypeIdListPipelineLinear': msg`Pipeline Linear by Offline Event`,
  'o.campaignTypeIdListClosedwonFirstTouch': msg`Closed Won First Touch by Offline Event`,
  'o.campaignTypeIdListClosedwonLinear': msg`Closed Won Linear by Offline Event`,
  'o.campaignIdListPipelineInfluence': msg`Pipeline Influence by Campaign`,
  'o.campaignIdListClosedwonInfluence': msg`Closed Won Influence by Campaign`,
  'o.campaignIdListPipelineFirstTouch': msg`Pipeline First Touch by Campaign`,
  'o.campaignIdListPipelineLastTouch': msg`Pipeline Last Touch by Campaign`,
  'o.campaignIdListPipelineLinear': msg`Pipeline Linear by Campaign`,
  'o.campaignIdListClosedwonFirstTouch': msg`Closed Won First Touch by Campaign`,
  'o.campaignIdListClosedwonLinear': msg`Closed Won Linear by Campaign`,
};

export const getOpportunityActivityFieldName = (fieldId: ALL_OPPORTUNITY_ACTIVITY_FIELDS) =>
  i18n._(OPPORTUNITY_ACTIVITY_FIELD_MESSAGES[fieldId]);
